// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__33elF","vLegacy":"SelectSecondary_vLegacy__3_RbM","error":"SelectSecondary_error__cuikV","disabled":"SelectSecondary_disabled__2l5wm"};